import Menu from '../Menu'

import arrowBottom from 'assets/arrow-bottom-wide.svg'
import arrowTop from 'assets/arrow-top-wide.svg'
import back from 'assets/back-button.svg'
import avatar from 'assets/person.svg'
import logoutIcon from 'assets/logout.svg'

import { useAuth } from 'features/common/context/auth'
import { useUser } from 'features/authorized/context/user'
import useLanguageSelect from 'features/common/hooks/useLanguageSelect'
import { useTranslation } from 'react-i18next'

const Header = ({ onClickBack }: { onClickBack?: () => void }) => {
    const { t } = useTranslation()
    const { logout } = useAuth()
    const { user } = useUser()
    const name = user?.name
    const title = user?.organization.name
    const { language, languageList, onChangeLanguage } = useLanguageSelect()

    return (
        <div className="relative grid flex-1 grid-cols-3 py-2.5 font-bold">
            <div className="flex items-center">
                {onClickBack && (
                    <button onClick={onClickBack}>
                        <img src={back} alt="back" />
                    </button>
                )}
            </div>
            <div className="flex items-center justify-center text-2xl">
                {title}
            </div>
            <div className="flex items-center justify-end gap-7.5">
                <Menu as="div" className="relative">
                    <Menu.Button as="div" className="flex items-center gap-3">
                        {({ open }) => (
                            <>
                                <span className="cursor-pointer text-xl">
                                    {name}
                                </span>
                                <button className="flex items-center">
                                    <img
                                        src={open ? arrowTop : arrowBottom}
                                        alt="open"
                                    />
                                </button>
                            </>
                        )}
                    </Menu.Button>
                    <Menu.Items className="absolute right-0 top-full z-10 flex w-max flex-col gap-5 rounded-lg bg-yellow-40 p-4 text-xl text-white">
                        <Menu.Item>
                            <button className="flex gap-3" onClick={logout}>
                                <img src={logoutIcon} alt="avatar" />
                                <div>{t('HEADER_LOGOUT')}</div>
                            </button>
                        </Menu.Item>
                    </Menu.Items>
                </Menu>
                <img src={avatar} alt="avatar" />
                <Menu as="div" className="relative">
                    <Menu.Button as="div" className="flex items-center gap-3">
                        {({ open }) => (
                            <>
                                <span className="cursor-pointer">
                                    {language.toUpperCase()}
                                </span>
                                <button className="flex items-center">
                                    <img
                                        src={open ? arrowTop : arrowBottom}
                                        alt="open"
                                    />
                                </button>
                            </>
                        )}
                    </Menu.Button>
                    <Menu.Items className="absolute right-0 top-full z-10 flex w-max flex-col gap-5 rounded-lg bg-yellow-40 p-4 text-xl text-white">
                        {languageList.map((l) => (
                            <Menu.Item key={l}>
                                <button
                                    className="flex gap-3"
                                    onClick={() => onChangeLanguage(l)}
                                >
                                    <div>{l.toUpperCase()}</div>
                                </button>
                            </Menu.Item>
                        ))}
                    </Menu.Items>
                </Menu>
            </div>
        </div>
    )
}

export default Header
